var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.showTab
    ? _c(
        "div",
        {
          staticClass: "tab-pane fade in active",
          attrs: { id: "tab_member_documents" }
        },
        [
          _vm.loaders.vendors || _vm.pricingVendors.length > 0
            ? _c("div", { staticClass: "library__group h-center-align" }, [
                _c("div", { staticClass: "library__group-header" }, [
                  _vm._v("Pricing")
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "library__collection" },
                  [
                    _vm.loaders.vendors
                      ? _c(
                          "div",
                          { staticClass: "loading-indicator" },
                          [
                            _c("MoonLoader", {
                              attrs: { size: "75px", color: "#ffffff" }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm._l(_vm.pricingVendors, function(vendor, index) {
                      return _c("PricingCard", {
                        key: "pricing-" + index,
                        attrs: { vendor: vendor }
                      })
                    })
                  ],
                  2
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.loaders.documents || _vm.contracts.length > 0
            ? _c("div", { staticClass: "library__group h-center-align" }, [
                _c("div", { staticClass: "library__group-header" }, [
                  _vm._v("Contracts")
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "library__collection" },
                  [
                    _vm.loaders.documents
                      ? _c(
                          "div",
                          { staticClass: "loading-indicator" },
                          [
                            _c("MoonLoader", {
                              attrs: { size: "75px", color: "#ffffff" }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm._l(_vm.contracts, function(contract, index) {
                      return _c("ContractCard", {
                        key: "contract-" + index,
                        attrs: { contract: contract }
                      })
                    }),
                    _vm._v(" "),
                    _c("ContractModal", {
                      attrs: { "modal-key": "contractModal" }
                    })
                  ],
                  2
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.loaders.documents || _vm.edgeDocuments.length > 0
            ? _c("div", { staticClass: "library__group h-center-align" }, [
                _c("div", { staticClass: "library__group-header" }, [
                  _vm._v("EDGE Documents")
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "library__collection" },
                  [
                    _vm.loaders.documents
                      ? _c(
                          "div",
                          { staticClass: "loading-indicator" },
                          [
                            _c("MoonLoader", {
                              attrs: { size: "75px", color: "#ffffff" }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm._l(_vm.edgeDocuments, function(doc, index) {
                      return _c("EdgeCard", {
                        key: "edge-" + index,
                        attrs: { doc: doc }
                      })
                    })
                  ],
                  2
                )
              ])
            : _vm._e()
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }